import React, { useState } from 'react'
import Typography from '@mui/material/Typography'
import type { SxProps, Theme } from '@mui/material'
import { Alert, AlertTitle, Box } from '@mui/material'
import useCurrentProviderType from '@app/src/hooks/currentProviderType'
import { useIntl } from 'react-intl'

interface TopicalRiskComingSoonBannerProps {
  sx?: SxProps<Theme>
  highlightFlagFeatureReplacement?: boolean
}

const TopicalRiskComingSoonBanner: React.FC<TopicalRiskComingSoonBannerProps> = ({
  sx,
  highlightFlagFeatureReplacement,
}) => {
  const [visible, setVisible] = useState(true)
  const { formatMessage } = useIntl()
  const providerType = useCurrentProviderType()

  const handleClose = () => {
    setVisible(false)
  }

  if (!visible) return null

  return (
    <Box sx={sx}>
      <Alert severity="info" sx={{ alignItems: 'flex-start', borderRadius: '5px', py: 2.5 }} onClose={handleClose}>
        <AlertTitle sx={{ fontWeight: 600 }}>
          {formatMessage(
            { id: 'topicalRisk.comingSoonBanner.title' },
            {
              providerType,
            },
          )}
        </AlertTitle>
        <Typography variant="body1" sx={{ maxWidth: '1600px', whiteSpace: 'pre-wrap' }}>
          {formatMessage(
            { id: 'topicalRisk.comingSoonBanner.description' },
            {
              providerType,
              b: (chunks: React.ReactNode) =>
                highlightFlagFeatureReplacement ? (
                  <Typography fontWeight={600} component="span">
                    {chunks}
                  </Typography>
                ) : (
                  <>{chunks}</>
                ),
            },
          )}
        </Typography>
      </Alert>
    </Box>
  )
}

export default TopicalRiskComingSoonBanner
